import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules"; // Correct import for newer Swiper versions
import "swiper/css"; // Import core Swiper styles
import "swiper/css/pagination"; // Import pagination styles
import Title from "../Typography/Title";
import WhatWeOfferCard from "../Cards/WhatWeOfferCard";
import arrowImage from "../images/shaped-arrow.png";
import ideaImage from "../images/idea-img.png";

export default function WhatWeOffer() {
  const ServicesDataList = [
    {
      name: "Website Development",
      decs: "Building and maintaining websites so businesses can connect with customers, showcase their brand, and share important information online, all while ensuring a smooth user experience.",
    },
    {
      name: "Video Marketing",
      decs: "Creating videos to promote your brand or products, helping you reach more people, increase brand awareness, and boost sales through popular platforms like YouTube and social media.",
    },
    {
      name: "Ecommerce Solutions",
      decs: "Tools and services that help you sell online, including website design, payment processing, and inventory management, making it easy for customers to shop and for you to manage sales.",
    },
  ];

  return (
    <div className="flex md:mx-16    flex-col md:my-[40px] justify-center items-center relative gap-10">
      <Title title={"What we offer"} miniTitle={"services"} />

      {/* Swiper for mobile view */}
      <Swiper
        spaceBetween={15}
        slidesPerView={1} // Show slightly more than one slide at a time
        pagination={{ clickable: true }}
        style={{ paddingBottom: '40px' , gap:"20px" , display:"flex" } } 
        breakpoints={{
          768: {
            slidesPerView: 3, // Show multiple cards in desktop view
            spaceBetween: 20,
          },
        }}
        modules={[Pagination]} // Correct import of Pagination
        className="w-full gap-10 flex px-5 py-10"
      >
        {ServicesDataList.map((data, index) => (
          <SwiperSlide key={index}>
            <WhatWeOfferCard
              ServiceName={data.name}
              ServiceInfo={data.decs}
            />
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Gradient */}
      <div className="rounded-[100px] top-1/2 left-[-100px] bg-gradient-to-r rotate-90 from-[#00c3ffdb] to-[#FF29C3] absolute h-72 w-72 blur-[120px] "></div>

      <img
        src={arrowImage}
        alt="arrow"
        className="absolute h-44 md:h-52 top-[-60px] rotate-90 md:rotate-12 md:top-0 left-72 md:left-[-10px]"
      />
      <img
        src={ideaImage}
        alt="idea"
        className="absolute hidden md:block h-60 top-[-80px] left-[82%]"
      />
    </div>
  );
}
